module.exports = __webpack_public_path__ + "static/media/Kleenex.6630ba93.png";